import { LocalizationService } from '@abp/ng.core';
import { FieldDefinition } from '../../fields/field-definition';
import { FieldBuilder } from '../../fields/field-builder/field-builder.helper';
import { AuditUserLookupService } from '../../services/audit-user-lookup.service';
import { localizeWithFallback } from '../../utils/localization-utils';

type AuditFieldBuilder = {
  readOnly(): AuditFieldBuilder;
  hideByDefault(): AuditFieldBuilder;
  build(): FieldDefinition;
};

type AuditFieldConfig = {
  key: string;
  labelKey: string;
  type: 'number' | 'date' | 'foreignKey';
};

const AUDIT_FIELD_CONFIGS: readonly AuditFieldConfig[] = [
  { key: 'id', labelKey: 'Id', type: 'number' },
  {
    key: 'creationTime',
    labelKey: 'LanguageService::CreationTime',
    type: 'date',
  },
  {
    key: 'creatorId',
    labelKey: 'LanguageService::CreatorName',
    type: 'foreignKey',
  },
  {
    key: 'lastModificationTime',
    labelKey: 'LanguageService::LastModificationTime',
    type: 'date',
  },
  {
    key: 'lastModifierId',
    labelKey: 'LanguageService::LastModifierName',
    type: 'foreignKey',
  },
  {
    key: 'deletionTime',
    labelKey: 'LanguageService::DeletionTime',
    type: 'date',
  },
  {
    key: 'deleterId',
    labelKey: 'LanguageService::DeleterName',
    type: 'foreignKey',
  },
] as const;

export function buildAuditFields(localizationService: LocalizationService): FieldDefinition[] {
  return AUDIT_FIELD_CONFIGS.map(config => buildAuditField(config, localizationService));
}

function buildAuditField(
  config: AuditFieldConfig,
  localizationService: LocalizationService
): FieldDefinition {
  const label = localizeWithFallback(localizationService, config.labelKey);

  switch (config.type) {
    case 'number':
      return finalizeAuditField(FieldBuilder.number(config.key, label));
    case 'date':
      return finalizeAuditField(FieldBuilder.date(config.key, label));
    case 'foreignKey':
      return finalizeAuditField(
        FieldBuilder
          .foreignKey(config.key, label, AuditUserLookupService)
          .display('displayName')
      );
  }
}

function finalizeAuditField(builder: AuditFieldBuilder): FieldDefinition {
  return builder
    .readOnly()
    .hideByDefault()
    .build();
}
